import { isString } from "@payair/e-com-common-sdk/core/Validators";
import { MUST_BE_STRING, validateArray, validateParam } from "../core/Helpers";
import { validateGooglePaySelectionOption } from "./GooglePaySelectionOption";
export var validateGooglePayShippingOptionParameters = function (googlePayShippingOptionParameters) {
    var errorMessage = [];
    // shippingOptions: GooglePaySelectionOption[]
    var validationResult = validateArray(googlePayShippingOptionParameters.shippingOptions, validateGooglePaySelectionOption);
    var shippingOptions = validateParam(googlePayShippingOptionParameters.shippingOptions, "shippingOptions", validationResult === null, true, " ".concat(validationResult ? validationResult : ""));
    shippingOptions && errorMessage.push(shippingOptions);
    // defaultSelectedOptionId?: string | undefined
    var defaultSelectedOptionId = validateParam(googlePayShippingOptionParameters.defaultSelectedOptionId, "defaultSelectedOptionId", isString(googlePayShippingOptionParameters.defaultSelectedOptionId), false, MUST_BE_STRING);
    defaultSelectedOptionId && errorMessage.push(defaultSelectedOptionId);
    return errorMessage.length === 0 ? null : errorMessage.join(", ");
};
